module.exports = __webpack_public_path__ + "static/media/mbmu-logo.7fcd91ff.png";